import { useHightouchBillingQueryContext } from 'modules/billing/contexts/HightouchBillingQueryContext';
import { yesterdayDisplay } from 'modules/billing/utils';
import { WarningBanner } from 'ui/banner';
import { isDefined } from 'utils/tsHelpers';
import { AnalyticCard } from '../AnalyticCard';
import { ProjectBreakdownLink } from '../ProjectBreakdownLink';
import { SMART_INGEST_CARD_IDS, SMART_INGEST_CARD_TEXT } from './constants';

const {
  cardTitle,
  productionSyncsCountLabel,
  productionSyncsTooltip,
  projectBreakdownUrl,
  testSyncsCountLabel,
  testSyncsTooltip,
  warningBannerText,
} = SMART_INGEST_CARD_TEXT;

export const SmartIngestUsageCard = () => {
  const { hightouchOrg, isHightouchEnabled, isLoading } = useHightouchBillingQueryContext();
  const { allotment, productionSyncsCount, testSyncsCount } = hightouchOrg?.organization ?? {};

  const isOrgDefined = isDefined(hightouchOrg);

  const isWarning =
    isOrgDefined && (productionSyncsCount ?? 0) >= hightouchOrg.organization.allotment;

  const cardMetrics = [
    {
      limit: allotment || 0,
      metricDescription: productionSyncsTooltip,
      metricName: productionSyncsCountLabel,
      metricValue: productionSyncsCount || 0,
      timePeriod: 'maximum',
    },
    {
      metricDescription: testSyncsTooltip,
      metricName: testSyncsCountLabel,
      metricValue: testSyncsCount || 0,
      timePeriod: `As of ${yesterdayDisplay()}`,
    },
  ];

  if (!isHightouchEnabled) {
    return <></>;
  }

  return (
    <AnalyticCard
      CardAction={<ProjectBreakdownLink to={projectBreakdownUrl} />}
      data-test={SMART_INGEST_CARD_IDS.cardId}
      isLoading={isLoading}
      metrics={cardMetrics}
      title={cardTitle}
    >
      {isWarning && <WarningBanner isSubtle>{warningBannerText}</WarningBanner>}
    </AnalyticCard>
  );
};
